"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeisureCategoryResponseSchema = exports.LargeCategorySchema = exports.MediumCategorySchema = exports.SmallCategorySchema = void 0;
var zod_1 = require("zod");
var serverLogMetaSchema = zod_1.z.object({
    depth1LeisureCategoryNo: zod_1.z.string().nullish(),
    depth1LeisureCategoryName: zod_1.z.string().nullish(),
    depth2LeisureCategoryNo: zod_1.z.string().nullish(),
    depth2LeisureCategoryName: zod_1.z.string().nullish(),
});
exports.SmallCategorySchema = zod_1.z.object({
    id: zod_1.z.number(),
    title: zod_1.z.string(),
    available: zod_1.z.boolean(),
    icon: zod_1.z.string().nullish(),
    serverLogMeta: serverLogMetaSchema,
});
exports.MediumCategorySchema = zod_1.z.object({
    id: zod_1.z.number(),
    title: zod_1.z.string(),
    available: zod_1.z.boolean(),
    icon: zod_1.z.string().nullish(),
    serverLogMeta: serverLogMetaSchema,
    items: zod_1.z.array(exports.SmallCategorySchema).nullish(),
});
exports.LargeCategorySchema = zod_1.z.object({
    id: zod_1.z.number(),
    title: zod_1.z.string(),
    available: zod_1.z.boolean(),
    icon: zod_1.z.string().nullish(),
    serverLogMeta: serverLogMetaSchema,
    items: zod_1.z.array(exports.MediumCategorySchema).nullish(),
});
exports.LeisureCategoryResponseSchema = zod_1.z.array(exports.LargeCategorySchema);
